"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableHeading_1 = __importDefault(require("components/common/table/TableHeading"));
var ProductSpecificationsTableRow_1 = __importDefault(require("./ProductSpecificationsTableRow"));
var ProductSpecificationsTable = function (_a) {
    var sort = _a.sort, data = _a.data, onChangeSort = _a.onChangeSort, onDelete = _a.onDelete, products = _a.products;
    console.log(data);
    return (react_1.default.createElement("div", { className: 'table' },
        react_1.default.createElement("div", { className: 'table__head flex flex-row' },
            react_1.default.createElement(TableHeading_1.default, { name: 'Name', sortable: true, active: sort.name === 'Name', direction: sort.direction, onChange: onChangeSort }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Items', sortable: true, active: sort.name === 'Items', direction: sort.direction, onChange: onChangeSort }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Featured on', sortable: true, active: sort.name === 'Featured on', direction: sort.direction, onChange: onChangeSort }),
            react_1.default.createElement(TableHeading_1.default, { name: 'Action', sortable: false })),
        react_1.default.createElement("div", { className: 'table__body' },
            data.map(function (productSpec) { return (react_1.default.createElement(ProductSpecificationsTableRow_1.default, { key: productSpec.id, data: productSpec, onDelete: onDelete, products: products })); }),
            data.length <= 0 &&
                react_1.default.createElement("p", { className: 'table__empty' }, "There are no product specifications to show"))));
};
exports.default = ProductSpecificationsTable;
